/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { HealthCheckFunction } from '../../HealthCheckFunction.tsx';

const globalObj = window || global;
const defaultHealthcheck = (callback: (obj?: { isSuccess: boolean }) => void) =>
	callback({ isSuccess: true });

export const provideHealthcheck = (healthcheck: HealthCheckFunction = defaultHealthcheck): void => {
	globalObj.performHealthcheck = healthcheck;
};
